import axios from "axios";
import Common from '@/common.js'


const state = {
    products:{},
    featuredProducts:{}
};
const getters = {
    AllProducts: state => state.products,
    FeaturedProducts: state => state.featuredProducts
};
const actions = {
    async getProducts({commit}){
        var url = Common.getApiCallUrl("Items/ItemController::GetProducts");
        const response = await axios.post(url,{},Common.getRequestHeader());
        var data = Common.mapResponse(response.data)
        commit("setProducts",data);
   },
   async getFeaturedProducts({commit}){
    var url = Common.getApiCallUrl("Items/ItemController::GetFeaturedItems");
    const response = await axios.post(url,{},Common.getRequestHeader());
    var data = Common.mapResponse(response.data)
    commit("setFeaturedProducts",data);
}

};
const mutations = {
    setProducts:(state, products) => (state.products = (typeof response =='object' ? products : JSON.parse(products))),
    setFeaturedProducts:(state, products) => (state.featuredProducts = (typeof response =='object' ? products : JSON.parse(products)))
};

export default{
    state,
    getters,
    actions,
    mutations
};